// src/components/getp2p.js
import axios from "axios";

/* ======================================================
   GET /api/p2p/payment-details?sellerChatId=XXX
====================================================== */
export async function fetchSellerPaymentDetails(sellerChatId) {
  try {
    if (!sellerChatId?.trim()) {
      throw new Error("sellerChatId is required");
    }

    const res = await axios.get("/api/p2p/payment-details", {
      params:          { sellerChatId },
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    const message =
      err?.response?.data?.error ||
      err?.message ||
      "Failed to fetch payment details";

    throw err;
  }
}

/* ======================================================
   GET /api/p2p/my-payment-profile
====================================================== */
export async function fetchMyPaymentProfile() {

  try {

    const res =
      await axios.get(
        "/api/p2p/my-payment-profile",
        {
          withCredentials: true,
        }
      );

    return res.data;

  } catch (err) {

    throw err;

  }

}

/* ======================================================
   GET /api/p2p/order-history
====================================================== */
export async function fetchOrderHistory() {
  try {
    const res = await axios.get("/api/p2p/order-history", {
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    const message =
      err?.response?.data?.error ||
      err?.message ||
      "Failed to fetch order history";

    throw err;
  }
}

/* ======================================================
   GET /api/p2p/offers?asset=XXX
====================================================== */
export async function fetchOffers(
  asset,
  currency = null,
  page = 1,
  limit = 50
) {
  try {

    if (!asset?.trim()) {
      throw new Error(
        "asset is required"
      );
    }

    const params = {
      asset,
      page,
      limit,
    };

    if (currency?.trim()) {
      params.currency =
        currency
          .trim()
          .toUpperCase();
    }

    const res =
      await axios.get(
        "/api/p2p/offers",
        {
          params,
          withCredentials: true,
        }
      );

    return res.data;

  } catch (err) {

    const message =

      err?.response?.data?.error ||

      err?.message ||

      "Failed to fetch offers";

    throw err;
  }
}